
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white pt-12 sm:pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-10 sm:mb-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/aa2ff2400bfafb6f4ad0dde7508c4a41/99519d97d87bafed31d0d8d3a2ef2c87.png"
                alt="Parker Family Tech"
                className="h-10 w-10 object-contain"
              />
              <span className="text-xl font-bold">Parker Family Tech</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Your trusted local computer repair experts. Family-owned and operated, providing quality service to our community since 2026.
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-full hover:border-teal-600 hover:text-teal-600 transition-colors"
              >
                <i className="ri-facebook-fill"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-full hover:border-teal-600 hover:text-teal-600 transition-colors"
              >
                <i className="ri-instagram-line"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-full hover:border-teal-600 hover:text-teal-600 transition-colors"
              >
                <i className="ri-twitter-x-line"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center border border-gray-700 rounded-full hover:border-teal-600 hover:text-teal-600 transition-colors"
              >
                <i className="ri-linkedin-fill"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Services</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('pc-repair')}
                  className="text-gray-400 hover:text-teal-600 transition-colors text-sm cursor-pointer"
                >
                  PC Repair
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('chromebook-repair')}
                  className="text-gray-400 hover:text-teal-600 transition-colors text-sm cursor-pointer"
                >
                  Chromebook Repair
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('software')}
                  className="text-gray-400 hover:text-teal-600 transition-colors text-sm cursor-pointer"
                >
                  Software Services
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-teal-600 mt-0.5"></i>
                <span>Kernersville, NC</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-teal-600 mt-0.5"></i>
                <span>(336) 310-9067</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-teal-600"></i>
                <span className="break-all">Parkerfamilytech@gmail.com</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Business Hours</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li className="flex justify-between gap-4">
                <span>Monday-Friday</span>
                <span className="whitespace-nowrap">By Appointment</span>
              </li>
              <li className="flex justify-between gap-4">
                <span>Saturday</span>
                <span className="whitespace-nowrap">By Appointment</span>
              </li>
              <li className="flex justify-between gap-4">
                <span>Sunday</span>
                <span className="whitespace-nowrap">By Appointment</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-xs sm:text-sm text-gray-400 text-center sm:text-left">
              © 2025 Parker Family Tech. All rights reserved.
            </p>
            <div className="flex items-center gap-4 sm:gap-6 text-xs sm:text-sm text-gray-400">
              <a href="#" className="hover:text-teal-600 transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-teal-600 transition-colors">Terms of Service</a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer nofollow" className="hover:text-teal-600 transition-colors">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
